import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { SnWidget } from '@lib/api/entities';
import { SnOperationalViewsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-form-edit-title',
  templateUrl: './form-edit-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormEditTitleComponent implements OnInit, OnDestroy {
  public formFieldTitle: SnFormFieldConfig[];

  public editFormTitle = new UntypedFormGroup({});

  public formModel: any = {};

  @Input() public readonly widget: SnWidget;

  @Input() public readonly viewId: string;

  @Output() public readonly title = new EventEmitter<boolean>();

  @Output() public readonly updateTitle = new EventEmitter<any>();

  private readonly _destroy$ = new Subject<void>();

  constructor(private readonly _operationalViewsAPI: SnOperationalViewsAPI) {}

  public ngOnInit(): void {
    this._initFieldTitleEdit();
    this._setForm();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    this._operationalViewsAPI
      .updateViewWidget(this.viewId, this.widget.id, this.formModel)
      .pipe(takeUntil(this._destroy$))
      .subscribe((updatedWidget) => {
        this.title.emit(false);
      });
  }

  private _initFieldTitleEdit(): void {
    this.formFieldTitle = [
      {
        key: 'name',
        type: 'input',
        templateOptions: {
          appearance: 'outline',
          floatLabel: 'always',
          placeholder: t('dashboard.operational.widgets.enterTitle'),
          required: true,
          label: t('common.title'),
          keydown: (field, event) => {
            if (event.key === 'Enter') {
              if (this.formModel.name) {
                this.updateTitle.emit(this.formModel.name);
                this.submitForm();
              } else {
                return;
              }
            }
          },
        },
      },
    ];
  }

  private _setForm(): void {
    this.formModel.name = this.widget.name;
  }
}
